import ArrowForward from "../../../../assets/svg/arrow-small-forward.svg?react";

interface RightArrowProps {
  onClick?: () => void;
}

export function RightArrow({ onClick }: RightArrowProps) {
  return <ArrowForward onClick={onClick} />;
}
